module.exports = __webpack_public_path__ + "img/bottom.796bffd8.png";